import threeDimentional from './images/three_dimentional.svg';
import flat_minimalist from './images/flat_minimalist.svg';
import hand_drawn from './images/hand_drawn.svg';
import mascot_cartoon from './images/mascot_cartoon.svg';
import retro from './images/retro.svg';
import signature from './images/signature.svg';
import watercolor_feminine from './images/watercolor_feminine.svg';
import thumbnails from './images/thumbnails.svg';
import panels from './images/panels.svg';
import overlays_screen_packs from './images/overlays_screen_packs.svg';
import emotes_badges from './images/emotes_badges.svg';
import banners from './images/banners.svg';
import alerts from './images/alerts.svg';
import ads_social_media_videos from './images/ads_social_media_videos.svg';
import corporate_videos from './images/corporate_videos.svg';
import elearning from './images/elearning.svg';
import event_videos from './images/event_videos.svg';
import explainer_videos from './images/explainer_videos.svg';
import family_videos from './images/family_videos.svg';
import gaming_videos from './images/gaming_videos.svg';
import movie_trailers from './images/movie_trailers.svg';
import music_videos from './images/music_videos.svg';
import showreels from './images/showreels.svg';
import fiction_films from './images/fiction_films.svg';
import vr_360_video from './images/vr_360_video.svg';
import view_all from './images/view_all.svg';
import male from './images/male.svg';
import female from './images/female.svg';
import arabic from './images/arabic.svg';
import english from './images/english.svg';
import french from './images/french.svg';
import german from './images/german.svg';
import italian from './images/italian.svg';
import spanish from './images/spanish.svg';
import dutch from './images/dutch.svg';
import beauty_fashion from './images/beauty_fashion.svg';
import business_finance_law from './images/business_finance_law.svg';
import health_medical from './images/health_medical.svg';
import internet_technology from './images/internet_technology.svg';
import lifestyle from './images/lifestyle.svg';
import marketing from './images/marketing.svg';
import facebook from './images/facebook.svg';
import twitter from './images/twitter.svg';
import etsy from './images/etsy.svg';
import instagram from './images/instagram.svg';
import linkedin from './images/linkedin.svg';
import youtube from './images/youtube.svg';
import investor_pitch_fundraising from './images/investor_pitch_fundraising.svg';
import business_proposal from './images/business_proposal.svg';
import education_training from './images/education_training.svg';
import sales from './images/sales.svg';
import conference from './images/conference.svg';
import shopify from './images/shopify.svg';
import amazon from './images/amazon.svg';
import ebay from './images/ebay.svg';
import woocommerce from './images/woocommerce.svg';
import wix from './images/wix.svg';
import magento from './images/magento.svg';
import opencart from './images/opencart.svg';
import bigcommerce from './images/bigcommerce.svg';
import prestashop from './images/prestashop.svg';
import squarespace from './images/squarespace.svg';
import godaddy from './images/godaddy.svg';
import sitebuilder from './images/sitebuilder.svg';
import webflow from './images/webflow.svg';
import blog from './images/blog.svg';
import business from './images/business.svg';
import education from './images/education.svg';
import portfolio from './images/portfolio.svg';
import entertainment from './images/entertainment.svg';
import wedding from './images/wedding.svg';
import sports_games from './images/sport_games.svg';
import twoD from './images/twoD.svg';
import threeD from './images/threeD.svg';
import guitar from './images/guitar.svg';
import drums from './images/drums.svg';
import bass from './images/bass.svg';
import piano from './images/piano.svg';
import keyboards from './images/keyboards.svg';
import pop from './images/pop.svg';
import hip_hop from './images/hip_hop.svg';
import rap from './images/rap.svg';
import r_b from './images/r_b.svg';
import edm from './images/edm.svg';
import illustrative from './images/illustrative.svg';
import photographic from './images/photographic.svg';
import typographic from './images/typographic.svg';
import digital from './images/digital-pattern.svg';
import hand_drawn_pattern from './images/hand_drawn-pattern.svg';
import cartoon_pattern from './images/cartoon-pattern.svg';
import realistic_pattern from './images/realistic-pattern.svg';
import seasonal from './images/seasonal.svg';
import collage from './images/collage.svg';
import for_children from './images/for_children.svg';
import realistic_drawing from './images/realistic_drawing.png';
import comic_cartoon from './images/comic_cartoon.png';
import manga from './images/manga.png';
import flat from './images/flat.png';
import line_art from './images/line_art.png';
import sketch from './images/sketch.png';
import mysql from './images/mysql.svg';
import ms_sql from './images/ms_sql.svg';
import access from './images/access.svg';
import oracle from './images/oracle.svg';
import sqlite from './images/sqlite.svg';
import postgres from './images/postgres.svg';
import mongo from './images/mongo.svg';
import teradata from './images/teradata.svg';
import freehand_digital from './images/freehand_digital.png';
import pen_ink from './images/pen_ink.png';
import vector_art from './images/vector_art.png';
import mixed_media from './images/mixed_media.png';
import watercolor from './images/watercolor.png';
import pencil from './images/pencil.png';
import abstract from './images/abstract.svg';

export default {
    '49': {
        '3d': threeDimentional,
        flat_minimalist,
        hand_drawn,
        mascot_cartoon,
        signature,
        retro,
        watercolor_feminine,
        view_all
    },
    '371': {
        thumbnails,
        panels,
        overlays_screen_packs,
        emotes_badges,
        banners,
        alerts,
        view_all
    },
    '99': {
        ads_social_media_videos,
        corporate_videos,
        elearning,
        event_videos,
        explainer_videos,
        family_videos,
        gaming_videos,
        movie_trailers,
        music_videos,
        fiction_films,
        showreels,
        vr_360_video,
        view_all
    },
    '163': {
        beauty_fashion,
        business_finance_law,
        health_medical,
        internet_technology,
        lifestyle,
        marketing,
        arabic,
        english,
        french,
        german,
        italian,
        spanish,
        dutch,
        view_all
    },
    '16': {
        arabic,
        english,
        french,
        german,
        italian,
        spanish,
        dutch,
        female,
        male,
        view_all
    },
    '67': {
        facebook,
        instagram,
        linkedin,
        twitter,
        youtube,
        view_all
    },
    '407': {
        facebook,
        instagram,
        linkedin,
        youtube,
        view_all
    },
    '54': {
        marketing,
        investor_pitch_fundraising,
        business_proposal,
        education_training,
        sales,
        conference,
        view_all
    },
    '325': {
        shopify,
        amazon,
        ebay,
        etsy,
        woocommerce,
        view_all
    },
    '139': {
        wix,
        magento,
        opencart,
        squarespace,
        prestashop,
        bigcommerce,
        godaddy,
        sitebuilder,
        webflow,
        shopify,
        amazon,
        ebay,
        woocommerce,
        view_all
    },
    '91': {
        blog,
        business,
        education,
        portfolio,
        entertainment,
        wedding,
        wix,
        magento,
        opencart,
        squarespace,
        prestashop,
        bigcommerce,
        godaddy,
        sitebuilder,
        webflow,
        shopify,
        amazon,
        ebay,
        woocommerce,
        view_all
    },
    '138': {
        blog_magazine: blog,
        corporate: business,
        education,
        portfolio,
        entertainment,
        wedding,
        wix,
        magento,
        opencart,
        squarespace,
        prestashop,
        bigcommerce,
        godaddy,
        sitebuilder,
        webflow,
        shopify,
        amazon,
        ebay,
        woocommerce,
        view_all
    },
    '334': {
        english,
        german,
        french,
        italian,
        spanish,
        view_all
    },
    '249': {
        weddings_events: wedding,
        family_travel: family_videos,
        corporate: corporate_videos,
        sports_games,
        elearning,
        view_all
    },
    '384': {
        english,
        spanish,
        french,
        german,
        arabic,
        view_all
    },
    '235': {
        '2d': twoD,
        '3d': threeD,
        view_all
    },
    '156': {
        guitar,
        drums,
        bass,
        piano,
        keyboards,
        view_all
    },
    '392': {
        pop,
        hip_hop,
        rap,
        r_b,
        edm,
        view_all
    },
    '51': {
        illustrative,
        photographic,
        typographic,
        view_all
    },
    '420': {
        abstract,
        digital,
        hand_drawn: hand_drawn_pattern,
        cartoon: cartoon_pattern,
        realistic: realistic_pattern,
        seasonal,
        collage,
        view_all
    },
    '50': {
        for_children,
        realistic_drawing,
        comic_cartoon,
        manga,
        flat,
        line_art,
        sketch,
        freehand_digital,
        vector_art,
        pen_ink,
        mixed_media,
        watercolor,
        pencil,
        view_all
    },
    '386': {
        photographic,
        illustrative,
        typographic,
        view_all
    },
    '87': {
        mysql,
        ms_sql,
        access,
        oracle,
        sqlite,
        postgres,
        mongo,
        teradata,
        view_all
    }
};
